export const AMPLITUDE_DEVICE_ID_HEADER = "X-Amplitude-Device-ID";

// Amplitude Browser SDK device ids are UUIDs, but custom ids are possible.
// Accept a conservative header-safe token so a tampered cookie can never
// inject an empty, oversized or non-ASCII header value.
const DEVICE_ID_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;

export const sanitizeAmplitudeDeviceId = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return DEVICE_ID_PATTERN.test(trimmed) ? trimmed : undefined;
};
